'use client';

import * as React from 'react';

import { cn } from '@workspace/ui/lib/utils';

import { GeneratorStep } from '~/schemas/generator/complete-generator-schema';

export type StepProps = React.HtmlHTMLAttributes<HTMLButtonElement> & {
  step: GeneratorStep;
  active: boolean;
  disabled: boolean;
  isValid?: boolean;
  setCurrentStep: (value: GeneratorStep) => void;
};

export function Step({
  step,
  active,
  disabled,
  isValid = false,
  setCurrentStep,
  className,
  ...other
}: StepProps): React.JSX.Element {
  const navigate = (): void => {
    setCurrentStep(step);
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  };
  return (
    <button
      className={cn(
        'border-t-4 w-full rounded-[1px] py-1 hover:border-primary',
        active
          ? 'border-primary'
          : isValid
            ? 'border-primary/60'
            : 'border-muted',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className
      )}
      type="button"
      tabIndex={-1}
      disabled={disabled}
      onClick={navigate}
      {...other}
    >
      <span className="text-sm font-medium">
        {step.charAt(0).toUpperCase() + step.slice(1)}
      </span>
    </button>
  );
}
